import { i18n, intlFormat } from '@fs/zion-locale'

// To cause less disturbance we are formatting dates like the backend did when in the en locale. We may change later to just using the international standard (with the en-GB locale that is the default for intlFormat)

/** Wrapper of Format intlFormat where we format as November 20, 2024 for US */
export function formatDate(ms: number): string {
  return intlFormat(new Date(ms), undefined, i18n.language === 'en' ? 'en-US' : undefined)
}
